import React, { useState, useEffect } from "react";
import { Package, ScrollText, AlertTriangle, DollarSign, Tag } from "lucide-react";
import { formatCurrency } from "../utils/currencyUtils";
import { useCurrency } from "../hooks/useCurrency"

const ShippingProductDisplay = ({ product, state, invalidProducts }) => {
  const calculateDiscountedPrice = (price, discount) => {
    return price - (price * discount) / 100;
  };
  const { currencyCode, exchangeLoaded } = useCurrency()
  return (
    <div className="w-full flex flex-col mt-2">
      <div className="flex sm:w-full gap-2">
        <div className="flex gap-2 justify-start items-center w-full">
          <img
            className="w-[80px] h-[80px] nex_img_cover rounded-sm"
            src={product.productInfo.images[0]}
            alt="product image"
          />
          <div className="px-2 text-gray-900 flex-grow">
            <div className="flex justify-between items-start">
              <div>
                <h2 className="text-md">{product.productInfo.name}</h2>
                <span className="text-sm">
                  Brand: {product.productInfo.brand}
                </span>
                <div className="text-sm mt-1">
                  Quantity: {product.quantity}
                </div>
              </div>
              <div className="flex flex-col items-end">
                <div className="flex items-center gap-2">
                  {product.productInfo.discount > 0 && (
                    <span className="text-sm line-through text-gray-400">
                      {formatCurrency(product.productInfo.price, currencyCode, exchangeLoaded)}
                    </span>
                  )}
                  <div className="flex items-center text-indigo-600">
                  <span className="mr-1">{currencyCode}</span> {" "}
                    <span className="font-semibold">
                      {calculateDiscountedPrice(
                        product.productInfo.price,
                        product.productInfo.discount
                      )}
                    </span>
                  </div>
                </div>
                {product.productInfo.discount > 0 && (
                  <div className="flex items-center text-green-500 text-sm mt-1">
                    <Tag size={14} className="mr-1" />
                    {product.productInfo.discount}% off
                  </div>
                )}
                {state.country && product.productInfo.shippingPrices?.[state.country] && (
                  <div className="text-sm text-gray-400 mt-1">
                    +{formatCurrency(product.productInfo.shippingPrices[state.country],currencyCode, exchangeLoaded)} shipping
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {state.country &&
        invalidProducts.includes(product.productInfo._id) && (
          <div className="mt-2 p-3 border border-red-500 rounded-md bg-red-500/10">
            <div className="flex items-center gap-2 text-red-500">
              <AlertTriangle className="h-4 w-4" />
              <p className="text-sm">
                This product does not ship to {state.country}.
                Please remove it from your cart to continue.
              </p>
            </div>
          </div>
        )}
    </div>
  );
};

export default ShippingProductDisplay;